export const layoutTheme = {
  LIGHTMODE: 'light',
  DARKMODE: 'dark',
}
